import * as actions from '../../actions/types';

const INITIAL_STATE = {
    projectManagers: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        }
    },
};

const projectManagersReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.GET_PROJECT_MANAGERS_LOADING:
            return {
                ...state,
                projectManagers: {
                    ...state.projectManagers,
                    get: {
                        ...state.projectManagers.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.projectManagers.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case actions.GET_PROJECT_MANAGERS_SUCCESS:
            return {
                ...state,
                projectManagers: {
                    ...state.projectManagers,
                    get: {
                        ...state.projectManagers.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.projectManagers.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case actions.GET_PROJECT_MANAGERS_FAILURE:
            return {
                ...state,
                projectManagers: {
                    ...state.projectManagers,
                    get: {
                        ...state.projectManagers.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.projectManagers.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
        case actions.GET_PROJECT_MANAGERS_RESET:
            return {
                ...state,
                projectManagers: {
                    ...state.projectManagers.get,
                    post: {
                        ...INITIAL_STATE.projectManagers.get,
                        reset: true,
                    },
                },
            }
    }
    return state;
}

export default projectManagersReducers;
